import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User initiated a Meta account connection',
  name: 'meta_account_connection_initiated',
  params: [
    {
      description: 'The location where the user initiated the Meta account connection',
      name: 'trackLocation',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
